import * as React from "react";
import {compose} from "redux";
import {withStyles} from "@material-ui/styles";

const styles: Record<string, Record<string, any>> = {
    wrappingDiv: {
        overflow: 'auto',
        maxWidth: '100%',
    },
    wrappingGridDiv: {
        display: 'grid',
    },
};

interface WrappingDivProps {
    classes?: Record<string, string>;
    children: any
}

const MaterialTableWrappingDiv: React.FunctionComponent<WrappingDivProps> =
    ({children, classes}: WrappingDivProps) => (
        <div className={classes?.wrappingGridDiv}>
            <div className={classes?.wrappingDiv}>
                {children}
            </div>
        </div>
    );

const StyledWrappingDiv = compose(withStyles(styles))(MaterialTableWrappingDiv);

export default StyledWrappingDiv;